import type { LessonMaterialFragment } from './lesson-material-fragment.generated';
import { LessonMaterialSmallText } from 'approot/shared/lesson-materials/lesson-materials-list.style';
import type { Pluck } from 'lib/gql/pluck';

const LessonMaterialsAlternatives = ({
  alternativeMaterials,
  dataSelector,
}: {
  alternativeMaterials: Pluck<LessonMaterialFragment, 'alternativeMaterials'>[];
  dataSelector?: string;
}) => (
  <LessonMaterialSmallText marginBottom={0} data-selector={dataSelector}>
    {`Alternative Materials: ${alternativeMaterials
      .map(am => am.name)
      .join(', ')}`}
  </LessonMaterialSmallText>
);

export default LessonMaterialsAlternatives;
